const GetURLSearchParameter = (key) => {
  const value = new URLSearchParams(window.location.search).get(key);

  return value;
};

export default GetURLSearchParameter;
